// dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// api services
import { getPageState, updatePageState } from "../../services";

export const usePageState = (pageName: string) => {
	return useQuery({
		queryKey: ["pageState", pageName],
		queryFn: async () => await getPageState(pageName),
		refetchOnWindowFocus: false,
		meta: {
			errorMessage: "There was an error getting the page State.",
		},
	});
};

export const useUpdatePageState = <Type>(pageName: string) => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["pageState", pageName],
		mutationFn: async ({ state, merge = false }: { state: Type; merge?: boolean }) => {
			await updatePageState(pageName, state);
			return { state, merge };
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["pageState", pageName] });
		},
	});
};
